import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../../services/auth.service';
import { FilterService } from '../../../services/filter.service';
import { EngineerService } from '../../../services/engineer.service';
import { Page } from '../../../models/paging/page';

@Component({
  selector: 'app-engineers',
  templateUrl: './engineers.component.html',
  styleUrls: ['./engineers.component.scss']
})
export class EngineerComponent implements OnInit {
  loading: boolean = false;
  readOnly: boolean = false;
  rows = [];
 page = new Page();
  filter: any = {
    company_Id: undefined,
    location_Id: undefined,
    name: '',
    email: ''
  };
  default_filters = JSON.parse(JSON.stringify(this.filter));
  constructor(private engineerService: EngineerService, public router: Router, private authService: AuthService, private filterService: FilterService) {
    if (this.authService.currentUser.value.userProfileId != 1 && this.authService.currentUser.value.userProfileId != 4) {
      this.readOnly = true;
    }   
    
    if (this.authService.currentUser.value.userProfileId == 3) {
      //user is a client, so throw them to the reports page
      this.router.navigate(['']);  
      }

    this.page.pageNumber = 0;
    this.page.size = 10;
    this.page.sortOrder = 'asc';
    this.page.sortBy = "firstname";

    var filters = this.filterService.getFilters(this.authService.currentUser.value.id, this.router.url);
    if (filters != null) {
      this.filter = filters;
      this.loadTable()
    }
  }

  ngOnInit(): void {
    this.getCounts();
    this.loadTable();
  }

  loadTable() {
    this.loading = true;
    this.engineerService.getTable(this.page, this.filter.company_Id, this.filter.location_Id, this.filter.name, this.filter.email).then((rows) => {
      //console.log(rows);
      this.page = rows.page;
      this.rows = rows.data;
      this.loading = false;
    });
  }
  licenseCount;
  activeUsers;
  totalUsers;
  expiredUsers;

  getCounts() {
    this.engineerService.getEngineerCounts().then((data) => {
      this.licenseCount = data.license;
      this.activeUsers = data.activeUsers;
      this.totalUsers = data.totalUsers;
      this.expiredUsers = data.license - data.activeUsers;
      ////console.log("engineer counts");
      ////console.log(data);
    });
  }
  rebind() {
    this.loadTable();
  }
  
  resetFilters() {
    this.filter = this.filterService.parseFilters(JSON.stringify(this.default_filters));
    this.loadTable();
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset;

    this.loadTable();
  }

  onSort(event) {
    if (event.column.prop == '') {
      return false;
    }
    this.loadTable();

  }

  add() {
    this.router.navigate(['engineers/manage']);
  }

    back() {
    this.router.navigate(['']);
  }
getRowClass = (row) => {
    return {
      'row-expired': row.expired,
      'row':true
    }
  }
}
